import { createSubSelector } from '../spaceKeyedSelectors';

export const SelectTextToSpeechState = createSubSelector(state => state.textToSpeech);
